// Copyright (c) 2016 Deere & Company

import Address, {getDefaultState as getAddressDefaultState} from './address';
import Business, {getDefaultState as getBusinessDefaultState} from './business';
import Individual, {getDefaultState as getIndividualDefaultState} from './individual';
import {getDefaultState as getPhoneDefaultState} from './phone';
import t from 'tcomb';

const Customer = t.struct({
    business: Business,
    ckcId: t.String,
    displayName: t.String,
    email: t.String,
    id: t.String,
    individual: Individual,
    mailingAddress: Address,
    phone: t.Array,
    physicalAddress: Address,
    type: t.String
}, {
    name: 'Customer',
    strict: true
});

export const getDefaultState = () => new Customer({
    business: getBusinessDefaultState(),
    ckcId: '',
    displayName: '',
    email: '',
    id: '',
    individual: getIndividualDefaultState(),
    mailingAddress: getAddressDefaultState(),
    phone: [getPhoneDefaultState()],
    physicalAddress: getAddressDefaultState(),
    type: ''
});

export default Customer;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/customer.js